<script>
export default {
  name: "breadcrumbTermsAndConditions"
}
</script>

<template>
  <el-row style="padding: 8px 15px 8px 15px; background-color: #003333">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/homepage' }"
        >Homepage</el-breadcrumb-item
        >
        <el-breadcrumb-item>Terms and Conditions</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<style scoped>
.el-breadcrumb__item /deep/ .el-breadcrumb__separator {
  color: #fff;
  font-weight: 600;
}

.el-breadcrumb__item /deep/ .el-breadcrumb__inner {
  color: #fff;
  font-family: DINosaur-a, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/terms/breadcrumbTermsAndConditions.vue